import { PutHomologarTitularMayor } from "../../../reducers/personaReferencia";

export interface HomologarTitularMayorStore extends PutHomologarTitularMayor {}

export const homologarTitularMayorStore: (
  state
) => HomologarTitularMayorStore = state => {
  const { personaReferencia } = state;
  return {
    puttingHomologarTitularMayor:
      personaReferencia.puttingHomologarTitularMayor,
    puttingHomologarTitularMayorError:
      personaReferencia.puttingHomologarTitularMayorError
  };
};
